import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, FormBuilder } from '@angular/forms';
import { ConfirmationService } from 'primeng/api';
import { select, Store } from '@ngrx/store';
import { IAppState } from '../../store/app.state';
import { Actions, ofType } from '@ngrx/effects';
import { map, tap } from 'rxjs/operators';
import { DownloadService } from 'src/app/services/download.service';
import { Table } from 'primeng/table';
import { selectInstitucionesList } from 'src/app/store/selectors/instituciones.selectors';
import {
  CreateInstituciones, CreateInstitucionesSuccess, DeleteInstituciones, DeleteInstitucionesSuccess, GetInstituciones, GetInstitucionesSuccess,
  UpdateInstituciones, UpdateInstitucionesSuccess
} from 'src/app/store/actions/instituciones.actions';
import { ICreateInstituciones, IInstituciones, IUpdateInstituciones } from 'src/app/interfaces/instituciones.interface';
import { AuthenticationService } from '../../services/authentication.service';
import { ExportExcelService } from 'src/app/services/export-excel.service';

@Component({
  selector: 'app-instituciones',
  templateUrl: './instituciones.component.html',
  styleUrls: ['./instituciones.component.scss']
})
export class InstitucionesComponent implements OnInit, OnDestroy {
  @ViewChild('dt', { static: false }) table: Table;

  instituciones = this.store$.pipe(
    select(selectInstitucionesList),
    map(instituciones => instituciones.map(institucion => {
      this.institucionesExcel.push(institucion)
      return {
        ...institucion
      }
    }))
  );

  getSubscription = this.actions$.pipe(
    ofType(GetInstitucionesSuccess),
  ).subscribe(_ => {
    // this.currentToken = this.authenticationService.currentTokenValue;
  });

  cols: any[];
  exportColumns: any[];
  mode = '';
  header = '';
  displayForm = false;
  currentToken = '';
  formInstitucion: FormGroup;
  institucionesExcel = [];
  dataForExcel = [];
  displayInfo = false;
  dialogCount: any;

  tipoInstitucion = [
    { label: 'Pública', value: 'pública' },
    { label: 'Privada', value: 'privada' }
  ];

  tipoPoder = [
    { label: 'Ejecutivo', value: 'ejecutivo' },
    { label: 'Legislativo', value: 'legislativo' },
    { label: 'Judicial', value: 'judicial' }
  ];

  tipoNivel = [
    { label: 'Municipal', value: 'municipal' },
    { label: 'Estatal', value: 'estatal' },
    { label: 'Federal', value: 'federal' }
  ];

  tipoOrganizacion = [
    { label: 'Agrupación ', value: 'agrupacion' },
    { label: 'OSC', value: 'osc' },
    { label: 'Colectivo', value: 'colectivo' },
    { label: 'Red', value: 'red' },
    { label: 'Otra', value: 'otra' }
  ];

  downloadItems = [
    { label: 'CSV', command: () => { this.downloadService.exportCSV('programas', this.table) } },
    { label: 'PDF', command: () => { this.downloadService.exportPdf('programas', this.table) } },
  ];

  formSubmitSubscription = this.actions$.pipe(
    ofType(UpdateInstitucionesSuccess, DeleteInstitucionesSuccess, CreateInstitucionesSuccess),
    tap(_ => {
      this.store$.dispatch(GetInstituciones());
      this.displayForm = false;
    })
  ).subscribe();

  constructor(
    private formBuilder: FormBuilder,
    private confirmationService: ConfirmationService,
    private store$: Store<IAppState>,
    private actions$: Actions,
    public downloadService: DownloadService,
    private authenticationService: AuthenticationService,
    private ete: ExportExcelService
  ) {
    this.currentToken = this.authenticationService.currentTokenValue;

    this.formInstitucion = this.formBuilder.group({
      _id: new FormControl(''),
      institucion: new FormControl(''),
      tipo_institucion: new FormControl(''),
      siglas: new FormControl(''),
      secretaria: new FormControl(''),
      poder: new FormControl(''),
      nivel_gobierno: new FormControl(''),
      tipo_organizacion: new FormControl(''),
      tematica: new FormControl(''),
      poblacion: new FormControl(''),
      website: new FormControl(''),
      facebook: new FormControl(''),
      instagram: new FormControl(''),
      contacto: new FormControl(''),
      telefono_contacto: new FormControl(''),
      correo_contacto: new FormControl(''),
      puesto: new FormControl(''),
      correo: new FormControl(''),
      telefono: new FormControl(''),
      programas: new FormControl('')
    });
  }

  ngOnInit() {
    this.cols = [
      { field: 'institucion', header: 'Institución', exportable: true },
      { field: 'tipo_institucion', header: 'Tipo Institución', exportable: true },
      { field: 'telefono_contacto', header: 'Telefono Institución', exportable: true },
      { field: 'correo_contacto', header: 'Correo Institución', exportable: true },
      { field: 'website', header: 'Website', exportable: true },
      { field: 'acciones', header: 'Acciones', exportable: false }
    ];

    // this.dialogCount = 0;
    // this.manualDisplay();
    this.store$.dispatch(GetInstituciones());
  }

  ngOnDestroy() {
    this.formSubmitSubscription.unsubscribe();
  }

  // manualDisplay() {
  //   console.log(this.dialogCount);
  //   if(this.dialogCount === 0) {
  //     this.displayInfo = true;
  //     this.dialogCount = 1;
  //   } else {

  //   }
  // }

  editarInstitucion(institucion): void {
    this.mode = 'EDITAR'
    this.header = 'Editar Institución';
    this.formInstitucion.patchValue({
      ...institucion
    });
    this.formInstitucion.enable();

    this.displayForm = true;
  }

  verInstitucion(institucion): void {
    this.mode = 'DETALLE'
    this.header = 'Detalle Institución'
    this.formInstitucion.patchValue({
      ...institucion
    });
    this.formInstitucion.disable();

    this.displayForm = true;
  }

  agregarInstitucion() {
    this.mode = 'AGREGAR'
    this.header = 'Agregar Institución'
    this.formInstitucion.patchValue({
      _id: '',
      institucion: '',
      tipo_institucion: '',
      siglas: '',
      secretaria: '',
      poder: '',
      nivel_gobierno: '',
      tipo_organizacion: '',
      tematica: '',
      poblacion: '',
      website: '',
      facebook: '',
      instagram: '',
      contacto: '',
      telefono_contacto: '',
      correo_contacto: '',
      puesto: '',
      correo: '',
      telefono: '',
      programas: ''
    })
    this.formInstitucion.enable();

    this.displayForm = true;
  }

  borrarInstitucion(institucion: IInstituciones) {
    this.confirmationService.confirm({
      header: 'Borrar Institución',
      message: `¿Seguro que quiere borrar la institución '${institucion.institucion}'?`,
      acceptLabel: 'Aceptar',
      rejectVisible: false,
      accept: async () => {
        this.store$.dispatch(DeleteInstituciones({ id: institucion._id }))
      }
    });
  }

  submitForm() {
    const form: IInstituciones = this.formInstitucion.getRawValue();

    if (this.mode === 'AGREGAR') {
      const payload: ICreateInstituciones = {
        ...form,
      }

      this.store$.dispatch(CreateInstituciones({ institucion: payload }));
    } else if (this.mode === 'EDITAR') {
      const payload: IUpdateInstituciones = {
        ...form,
      }

      this.store$.dispatch(UpdateInstituciones({ id: form._id, institucion: payload }));
    }

    return;
  }

  exportToExcel() {
    this.dataForExcel = [];

    const uniqueArray = this.institucionesExcel.filter((value, index) => {
      const _value = JSON.stringify(value);
      return index === this.institucionesExcel.findIndex(obj => {
        return JSON.stringify(obj) === _value;
      });
    });

    uniqueArray.forEach((row: any) => {
      const insert = { ...row }
      this.dataForExcel.push(Object.values(insert))
    })

    const headers = {
      id: '',
      Institucion: '',
      'Tipo de Institucion': '',
      Siglas: '',
      Secretaria: '',
      Poder: '',
      'Nivel de Gobierno': '',
      'Tipo de Organizacion': '',
      Tematica: '',
      Poblacion: '',
      Website: '',
      Facebook: '',
      Instagram: '',
      Contacto: '',
      'Telefono de Contacto': '',
      'Correo de Contacto': '',
      Puesto: '',
      Correo: '',
      Telefono: ''
    }

    const reportData = {
      title: 'Instituciones',
      data: this.dataForExcel,
      headers: Object.keys(headers)
    }

    this.ete.exportExcel(reportData, false);
  }
}
